import Grab from './grab.cursor.svg';
import Grabbing from './grabbing.cursor.svg';
import Loading from './loading.cursor.svg';
import Move from './move.cursor.svg';
import NotAllowed from './not-allowed.cursor.svg';
import Resize from './resize.cursor.svg';
import Rotation from './rotation.cursor.svg';
import Text from './text.cursor.svg';
import ViewportDefault from './viewport-default.cursor.svg';
import ZoomIn from './zoom-in.cursor.svg';
import ZoomOut from './zoom-out.cursor.svg';

export const CURSORS = {
  GRAB: Grab,
  GRABBING: Grabbing,
  LOADING: Loading,
  MOVE: Move,
  NOT_ALLOWED: NotAllowed,
  RESIZE: Resize,
  ROTATION: Rotation,
  TEXT: Text,
  VIEWPORT_DEFAULT: ViewportDefault,
  ZOOM_IN: ZoomIn,
  ZOOM_OUT: ZoomOut,
};
